import { Platform } from 'react-native';
import { Colors } from '../constants/Colors';

let stylesInjected = false;

/**
 * Injects global scrollbar styles for web platform.
 * Call this once in the root layout of your app.
 * Safe to call multiple times - will only inject once.
 */
export const injectGlobalScrollbarStyles = (): void => {
  if (Platform.OS !== 'web' || stylesInjected) {
    return;
  }

  const styleId = 'sunrise-global-scrollbar-styles';

  // Check if already injected (e.g., from another app in the same window)
  if (document.getElementById(styleId)) {
    stylesInjected = true;
    return;
  }

  const style = document.createElement('style');
  style.id = styleId;
  style.textContent = `
    /* Global scrollbar styles for all scrollable elements */
    * {
      scrollbar-width: thin;
      scrollbar-color: ${Colors.opacity20} transparent;
    }

    /* Webkit browsers (Chrome, Safari, Edge) */
    *::-webkit-scrollbar {
      width: 8px;
      height: 8px;
    }

    *::-webkit-scrollbar-track {
      background: transparent;
    }

    *::-webkit-scrollbar-thumb {
      background-color: ${Colors.opacity20};
      border-radius: 4px;
    }

    *::-webkit-scrollbar-thumb:hover {
      background-color: ${Colors.opacity40};
    }
  `;

  document.head.appendChild(style);
  stylesInjected = true;
};
